<template>
  <pop-sticky-bar class="popup">
    <b-title
      slot="banner"
      :title="title"
      :show-back="showBack"
      :show-close="showClose"
      :right-button-title="rightActionTitle"
      @close="onClose"
      @rightAction="onReset"
    />
    <i-list-multi-select
      slot="main"
      name="job-types-list"
      :item-groups="options"
      :matcher="listItemMatcher"
      :value="value"
      group-selectable
      @input="change"
    />
    <b-main slot="actions" class="action-btn" :title="confirmButtonTitle" @click="onConfirm" />
  </pop-sticky-bar>
</template>

<script>
import ListMultiSelectInput from '../../input/select/listMultiSelectInput'
import MainButton from '../../button/mainButton'
import { matchItemByItemShortCode } from '../../../libs/mapping'
import PopupStickyBar from '../../popup/popupStickyBar'
import TitleBanner from '../../banner/titleBanner'

export default {
  components: {
    'b-main': MainButton,
    'b-title': TitleBanner,
    'i-list-multi-select': ListMultiSelectInput,
    'pop-sticky-bar': PopupStickyBar,
  },
  computed: {
    rightActionTitle() {
      if (this.showReset) {
        return this.$t('general.reset')
      }
      return ''
    },
  },
  data() {
    return {
      /**
       * List selected item matcher function
       */
      listItemMatcher: matchItemByItemShortCode,
    }
  },
  methods: {
    /**
     * on value change
     */
    change(newValue) {
      if (newValue && Array.isArray(newValue)) {
        this.$emit('change', newValue)
      }
    },
    /**
     * dismiss the screen
     */
    onClose() {
      this.$emit('close')
    },
    /**
     * confirm button click
     */
    onConfirm() {
      this.$emit('confirm')
    },
    /**
     * reset button click
     */
    onReset() {
      this.$emit('reset')
    },
  },
  props: {
    confirmButtonTitle: {
      default: '',
      type: String,
    },
    /**
     * all selection options
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * display back arrow
     */
    showBack: {
      default: false,
      type: Boolean,
    },
    showClose: {
      default: false,
      type: Boolean,
    },
    showReset: {
      default: false,
      type: Boolean,
    },
    /**
     * display title
     */
    title: {
      default: '',
      type: String,
    },
    /**
     * selected values
     */
    value: {
      default: () => [],
      type: Array,
    },
  },
}
</script>

<style scoped>
.popup {
  @apply fixed inset-0 z-10;
}

.action-btn {
  @apply w-full;
}
</style>
